import React from "react";
import "./card.scss";
import { IIconBasicProps } from "../../../assets/Icons/IIconBasicProps";
import RightArrowIcon from "../../../assets/Icons/RightArrowIcon/right_arrow"; // Adjust the import path as needed

type CardProps = {
  title: string;
  Icon: React.FC<IIconBasicProps>;
  onClick?: () => void;
  description?: string;
  className?: string; // Allows passing additional classes
  iconWidth?: number;  // Optional: Allow size customization for the icon
  iconHeight?: number; // Optional: Allow size customization for the icon
  navigation?:boolean;
  NavigationIcon?: React.FC<IIconBasicProps>; // Optional custom navigation icon
};

const Card: React.FC<CardProps> = ({ 
  title, 
  Icon, 
  onClick, 
  className = "", 
  description,
  iconWidth = 25,      // Default size
  iconHeight = 25 ,     // Default size
  navigation=false,
  NavigationIcon
}) => {
  return (
    <div className={`card ${className}`} onClick={onClick}>
      <Icon width={iconWidth} height={iconHeight} />  {/* Pass width and height to Icon */}
      <div className="card-content">
        <div className="card-title">{title}</div>
        {description && <div className="card-description">{description}</div>}
      </div>
      {navigation && (NavigationIcon ? <NavigationIcon width={24} height={24} /> : <RightArrowIcon className="right-arrow-icon" />)}
     
    </div>
  );
};

export default Card;
